'use client'
import React from 'react'
import { usePathname } from 'next/navigation'
import SideBarLink from '../links/SideBarLink'


export default function SideBarLinkComponents(props) {
  const { link, index } = props
  const pathname = usePathname()
  let isActive = false
  if(link.match === 'contains') {
    isActive = pathname.includes(link.href)
  } else {
    isActive = pathname === link.href
  }
  return (
    <SideBarLink link={link} index={index} isActive={isActive} key={`${link}-${index}`} />
  )
}
